import http from "./http";
import Service from "../Service";

/**
 * @type ProviderService
 */
export default class ProviderService extends Service {

	find_by_phone(phone) {
		return http.get(`clients/providers/sellers/byphone`, {
			headers: this.getHeaders(),
            params: {
                phone
            }
		});
	}

    export_xls(params) {
        return http.get(
            `/clients/providers/xls`,
            {
                params,
                headers: this.getHeaders(),
                responseType: "arraybuffer",
                timeout: 600000
            }
        );
    }

    show(id, params) {
		return http.get(`clients/providers/sellers/${id}`, {
			headers: this.getHeaders(),
            params
		});
	}

    load(params) {
		console.log(params);
		return http.get(`clients/providers/sellers`, {
            headers: this.getHeaders(),
            params
        });
	}

    loadPurchaseProviders(params) {
		return http.get(`clients/providers/v2`, {
            headers: this.getHeaders(),
            params
        });
	}

    /**
     * Homologa, recusa ou libera cotação/pedido de fornecedores do cliente logado.
     * @param {number[]} providerIds
     * @param {{ quotation_status?: "PENDING"|"HOMOLOGATED"|"BLOCKED", order_status?: "PENDING"|"HOMOLOGATED"|"BLOCKED" }} statuses
     * @returns resposta `{ updated: number }`
     */
    homologate(providerIds, { quotation_status, order_status } = {}) {
        return http.patch(`clients/providers/homologation`, {
            provider_ids: providerIds,
            quotation_status,
            order_status,
        }, {
            headers: this.getHeaders()
        });
    }

    /**
     * Fornecedores novos que ofertam/vendem produtos do cliente (ou da cotação, com filter[request_id]).
     * @returns paginado `{ data, links, meta }`
     */
    discover(params) {
        return http.get(`clients/providers/discover`, {
            headers: this.getHeaders(),
            params
        });
    }

    discoverProducts(providerId, params) {
        return http.get(`clients/providers/discover/${providerId}/products`, {
            headers: this.getHeaders(),
            params
        });
    }

    /**
     * Adiciona fornecedores à base do cliente e, com requestId, inclui na cotação.
     * @returns `{ linked, included, skipped_provider_ids }`
     */
    link(providerIds, requestId) {
        return http.post(`clients/providers/links`, {
            provider_ids: providerIds,
            request_id: requestId || undefined,
        }, {
            headers: this.getHeaders()
        });
    }

    load_providers(params) {
		return http.get(`clients/providers`, {
            headers: this.getHeaders(),
            params
        });
	}
	loadProvidersNew(params){
		return http.get(`admin/providers/all`, {
            headers: this.getHeaders(),
            params
        });
	}

	States() {
		return http.get(`clients/providers/sellers/states`, {
			headers: this.getHeaders(),


        });
	}

    blacklist(id, obs) {
		return http.post(`clients/providers/${id}/blacklist`, { obs }, {
			headers: this.getHeaders()
		});
	}

    remove_from_blacklist(id) {
		return http.delete(`clients/providers/${id}/blacklist`, {
			headers: this.getHeaders()
		});
	}

	create(provider) {
        return http.post(`clients/providers`, provider, {
                headers: this.getHeaders()
            }
        );
    }

	getReview(id){
		return http.get(`clients/providers/sellers/rating/`+id, {
			headers: this.getHeaders(),
        });
	}

}
